import { deviceFetch, DeviceResponse } from './client';
import type { DevicePlaylist, RegisterResult, StatusResult } from '@/types';

/** POST /api/display/screens/register — only when there is no stored screenId (SCN-612). */
export async function registerScreen(): Promise<RegisterResult> {
  const { data } = await deviceFetch<RegisterResult>('/api/display/screens/register', {
    method: 'POST',
  });
  return data!;
}

/** POST /api/display/screens/status — screenId in the body (SCN-762). 404 = row purged. */
export async function getStatus(screenId: string): Promise<StatusResult> {
  const { data } = await deviceFetch<StatusResult>('/api/display/screens/status', {
    method: 'POST',
    body: { screenId },
  });
  return data!;
}

/**
 * GET /api/display/screens/me/playlist with the ETag from the last poll.
 * 200 → new playlist + etag; 304 → data:null (unchanged); 204 → data:null (no playlist assigned).
 */
export function getPlaylist(
  token: string,
  etag: string | null,
): Promise<DeviceResponse<DevicePlaylist>> {
  return deviceFetch<DevicePlaylist>('/api/display/screens/me/playlist', { token, etag });
}

/** POST /api/display/screens/me/heartbeat — keeps the screen "Online" in the admin list. */
export async function sendHeartbeat(token: string): Promise<void> {
  await deviceFetch<void>('/api/display/screens/me/heartbeat', { method: 'POST', token });
}
